import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Link } from 'gatsby';

import EditorialNewsletterModule from '../editorial/editorial-newsletter-module';
import { HeaderPage } from './header';
import { useShopContext } from '../../state/shop-context';

import TwitterIcon from '../svgs/twitter-icon.js';
import IGIcon from '../svgs/ig-icon.js';
import RSSIcon from '../svgs/rss-icon.js';
import { ShopifyProductType } from 'superclient';
import HeaderSubnav from './header-subnav';

const HeaderFullscreen: FC<{
  pages: HeaderPage[];
  currentPage?: HeaderPage;
  isOpen: boolean;
  shopSubNav: boolean;
  shopNavHelper: (showSubNav) => void;
  onClose: () => void;
}> = ({ pages, currentPage, isOpen, shopSubNav, shopNavHelper, onClose }) => {
  const [isVisible, setIsVisible] = useState(isOpen);
  const { setProductTypeFilter } = useShopContext();

  useEffect(() => {
    let timeout: any;

    if (isOpen) {
      setIsVisible(true);
    } else {
      timeout = setTimeout(() => {
        setIsVisible(false);
      }, 300);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isOpen]);

  return (
    <div
      aria-hidden={!isVisible}
      // onClick={(e) => {
      //   const noRedirect = '.newsletter_module *';
      //   if (!(e.target as HTMLElement).matches(noRedirect)) {
      //     // onClose();
      //   }
      // }}
      // Removed in favor of the shopSubNav
      className={classNames(`header__mobile fix x y top f aic left bcy z4`, {
        open: isOpen,
        visible: isVisible
      })}
    >
      <div
        className="container--xl ma"
        style={{
          width: '100vw',
          maxHeight: 'calc(100vh - 240px)'
        }}
      >
        <div className="x fsHeaderGrid">
          <div className="f fr headerNav light-scrollbar-yellow ">
            <nav className="f1">
              <ul className="f fc">
                {pages.map((page, pageIndex) => {
                  if (page.title === 'Shop') {
                    return (
                      <HeaderSubnav
                        fullscreen={true}
                        currentPage={currentPage}
                        page={page}
                        pageIndex={pageIndex}
                        isExpanded={null}
                        isOpen={isOpen}
                        shopDropdown={null}
                        shopCategories={null}
                        shopSubNav={shopSubNav}
                        onClose={onClose}
                        shopNavHelper={shopNavHelper}
                        showShopDropdown={null}
                        closeShopDropdown={null}
                      />
                    );
                  } else
                    return (
                      <li
                        style={{ transitionDelay: `${(pageIndex + 1) * 0.05}s` }}
                        key={page.title}
                        className={'px15 py075'}
                      >
                        {page.title === 'Space Agency' ? (
                          <a
                            className={classNames(
                              'header__hamburger__link h2 asfs ' +
                                (shopSubNav ? 'shopSubNavActive_otherLinks' : ''),
                              {
                                header__hamburger__link_active:
                                  currentPage?.path === page.path
                              }
                            )}
                            onClick={() => {
                              onClose();
                              setTimeout(() => {
                                shopNavHelper(false);
                              }, 500);
                            }}
                            href={page.path}
                            aria-hidden={!isOpen}
                          >
                            {page.title}
                          </a>
                        ) : (
                          <Link
                            className={classNames(
                              'header__hamburger__link h2 asfs ' +
                                (shopSubNav ? 'shopSubNavActive_otherLinks' : ''),
                              {
                                header__hamburger__link_active:
                                  currentPage?.path === page.path
                              }
                            )}
                            onClick={() => {
                              onClose();
                              setTimeout(() => {
                                shopNavHelper(false);
                              }, 500);
                            }}
                            to={page.path}
                            aria-hidden={!isOpen}
                          >
                            {page.title}
                          </Link>
                        )}
                      </li>
                    );
                })}
              </ul>
            </nav>
          </div>
          <div className="f1 show--m headerCTA light-scrollbar-yellow">
            <div className="x y f fc jcb pr2">
              <EditorialNewsletterModule
                data={{
                  headline: 'Subscribe',
                  tagline: 'Space stories in your inbox, four times a month',
                  cta: 'Sign Up',
                  successMessage: 'We got you. More supercluster headed your way.',
                  placeholder: 'YOURNAME@EMAIL.COM'
                }}
                backgroundColor="rgba(255, 240, 3, 1)"
                padding={false}
              />

              <div>
                <h6 className="h3 m0 p0">Get the Supercluster App</h6>
                <div className="f fr ais jcs mt1">
                  <a
                    href="https://apps.apple.com/us/app/supercluster/id1500045135?ls=1"
                    className="caps btn btn__yellow btn--outline small ac"
                  >
                    IOS
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.supercluster.tracker"
                    className="caps btn btn__yellow ml1 btn--outline small ac bc"
                  >
                    ANDROID
                  </a>
                </div>
              </div>

              <div>
                <h6 className="h3 m0 p0">Donate to Support Supercluster</h6>
                <div className="f fr x aifs mt1">
                  <svg
                    height="45px"
                    version="1.1"
                    viewBox="0 0 88.84 89.1"
                    width="45px"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M88.84,35.26V88.93a26.83,26.83,0,1,1,0-53.67ZM30.89,37.65C22.14,51,16.19,60.11,0,62V89.1c31-2.34,43.47-21.35,53.49-36.66C62.56,38.57,69.29,28.28,88.84,27V0C54.57,1.48,41.49,21.45,30.89,37.65Z" />
                      </g>
                    </g>
                  </svg>
                  <p className="f1 small bau m0 ml1">
                    Your support makes the Astronaut Database and Launch Tracker
                    possible, and keeps all Supercluster content free.
                  </p>
                  <a
                    href="/support"
                    className="caps btn btn__yellow ml2 btn--outline small ac"
                  >
                    SUPPORT
                  </a>
                </div>
              </div>

              <div>
                <h6 className="h3 m0 p0">Supercluster on Patreon</h6>
                <div className="f fr x aifs mt1">
                  <svg
                    height="45px"
                    version="1.1"
                    viewBox="0 0 569 546"
                    width="45px"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>Patreon logo</title>
                    <g>
                      <circle
                        cx="362.589996"
                        cy="204.589996"
                        data-fill="1"
                        r="204.589996"
                      ></circle>
                      <rect
                        data-fill="1"
                        height="545.799988"
                        width="100"
                        x="0"
                        y="0"
                      ></rect>
                    </g>
                  </svg>
                  <p className="f1 small bau m0 ml1">
                    Your support makes the Astronaut Database and Launch Tracker
                    possible, and keeps all Supercluster content free.
                  </p>
                  <a
                    href="https://www.patreon.com/supercluster"
                    className="caps btn btn__yellow ml2 btn--outline small ac"
                  >
                    SUPPORT
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="abs bottom left x">
          <div className="container--xl ma p15 f fr">
            <div className="f1">
              <a
                href="https://twitter.com/SuperclusterHQ"
                target="blank"
                className="ml075 clickable"
                aria-label="Twitter"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://www.instagram.com/superclusterhq/"
                target="blank"
                className="ml075 clickable"
                aria-label="Instagram"
              >
                <IGIcon />
              </a>
              <a
                href="/rss.xml"
                target="blank"
                className="ml075 clickable"
                aria-label="RSS"
              >
                <RSSIcon />
              </a>
            </div>

            <div className="f1">
              <div className="show--m x">
                <div className="x f fr">
                  <a
                    href="http://grandarmy.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Grand Army"
                  >
                    <svg
                      className="mr15"
                      width="73px"
                      height="14px"
                      viewBox="0 0 73 14"
                      version="1.1"
                    >
                      <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="supercluster_website_desktop_dropbox_2018-11-20"
                          transform="translate(-60.000000, -1816.000000)"
                          fill="#000000"
                        >
                          <g
                            id="Group"
                            transform="translate(60.000000, 1816.000000)"
                          >
                            <path
                              d="M7.6104,9.7744 C6.8454,10.7624 5.8434,11.1384 4.8834,11.1384 C1.8074,11.1384 0.0004,8.8414 0.0004,5.9754 C0.0004,3.0254 1.8074,0.7304 4.8834,0.7304 C6.9134,0.7304 8.8354,1.9814 9.0704,4.2364 L6.9844,4.2364 C6.7334,3.1364 5.9124,2.5664 4.8834,2.5664 C2.9214,2.5664 2.1844,4.2364 2.1844,5.9754 C2.1844,7.6314 2.9214,9.3014 4.8834,9.3014 C6.3014,9.3014 7.1234,8.5354 7.2484,7.1584 L5.0504,7.1584 L5.0504,5.5294 L9.2244,5.5294 L9.2244,10.9014 L7.8324,10.9014 L7.6104,9.7744 Z"
                              id="Fill-42"
                            />
                            <path
                              d="M10.1008,3.7075 L11.9798,3.7075 L11.9798,5.0425 L12.0068,5.0425 C12.3698,4.1385 13.3428,3.5125 14.3028,3.5125 C14.4428,3.5125 14.6088,3.5405 14.7348,3.5825 L14.7348,5.4185 C14.5538,5.3775 14.2608,5.3505 14.0248,5.3505 C12.5778,5.3505 12.0778,6.3925 12.0778,7.6585 L12.0778,10.9005 L10.1008,10.9005 L10.1008,3.7075 Z"
                              id="Fill-44"
                            />
                            <path
                              d="M19.8552,7.3806 C19.5212,7.6716 18.8262,7.6866 18.2132,7.7976 C17.6012,7.9236 17.0442,8.1316 17.0442,8.8556 C17.0442,9.5926 17.6152,9.7746 18.2552,9.7746 C19.8002,9.7746 19.8552,8.5486 19.8552,8.1186 L19.8552,7.3806 Z M15.2912,5.9206 C15.4022,4.0686 17.0582,3.5136 18.6722,3.5136 C20.1052,3.5136 21.8312,3.8326 21.8312,5.5576 L21.8312,9.3016 C21.8312,9.9546 21.9002,10.6086 22.0822,10.9016 L20.0782,10.9016 C20.0082,10.6786 19.9532,10.4416 19.9382,10.2046 C19.3122,10.8596 18.3942,11.0956 17.5182,11.0956 C16.1542,11.0956 15.0682,10.4146 15.0682,8.9386 C15.0682,7.3106 16.2932,6.9216 17.5182,6.7536 C18.7272,6.5746 19.8552,6.6156 19.8552,5.8086 C19.8552,4.9596 19.2712,4.8336 18.5742,4.8336 C17.8232,4.8336 17.3372,5.1416 17.2672,5.9206 L15.2912,5.9206 Z"
                              id="Fill-46"
                            />
                            <path
                              d="M22.7634,3.7075 L24.6414,3.7075 L24.6414,4.7085 L24.6834,4.7085 C25.1844,3.9015 26.0464,3.5125 26.8824,3.5125 C28.9824,3.5125 29.5114,4.6955 29.5114,6.4765 L29.5114,10.9005 L27.5354,10.9005 L27.5354,6.8385 C27.5354,5.6555 27.1884,5.0715 26.2694,5.0715 C25.1994,5.0715 24.7394,5.6695 24.7394,7.1295 L24.7394,10.9005 L22.7634,10.9005 L22.7634,3.7075 Z"
                              id="Fill-48"
                            />
                            <path
                              d="M33.9644,5.0017 C32.6714,5.0017 32.2254,6.1137 32.2254,7.2967 C32.2254,8.4237 32.7404,9.6067 33.9644,9.6067 C35.2724,9.6067 35.6624,8.4657 35.6624,7.2837 C35.6624,6.1137 35.2454,5.0017 33.9644,5.0017 Z M35.6904,9.9817 L35.6624,9.9817 C35.2034,10.7617 34.3964,11.0957 33.4774,11.0957 C31.3084,11.0957 30.2494,9.2317 30.2494,7.2427 C30.2494,5.3077 31.3214,3.5127 33.4364,3.5127 C34.2854,3.5127 35.1194,3.8737 35.5794,4.5837 L35.5644,4.5837 L35.5924,4.5837 L35.5924,0.9667 L37.5684,0.9667 L37.5684,10.9007 L35.6904,10.9007 L35.6904,9.9817 Z"
                              id="Fill-50"
                            />
                            <path
                              d="M41.8123,7.061 L44.3863,7.061 L43.1343,3.416 L43.1063,3.416 L41.8123,7.061 Z M42.0203,0.966 L44.2613,0.966 L47.9763,10.901 L45.7093,10.901 L44.9563,8.689 L41.2423,8.689 L40.4633,10.901 L38.2513,10.901 L42.0203,0.966 Z"
                              id="Fill-53"
                            />
                            <path
                              d="M48.645,3.7075 L50.523,3.7075 L50.523,5.0425 L50.551,5.0425 C50.914,4.1385 51.887,3.5125 52.848,3.5125 C52.986,3.5125 53.153,3.5405 53.278,3.5825 L53.278,5.4185 C53.097,5.3775 52.805,5.3505 52.569,5.3505 C51.122,5.3505 50.621,6.3925 50.621,7.6585 L50.621,10.9005 L48.645,10.9005 L48.645,3.7075 Z"
                              id="Fill-54"
                            />
                            <path
                              d="M53.9883,3.7075 L55.8523,3.7075 L55.8523,4.6815 L55.8803,4.6815 C56.3943,3.9445 57.1463,3.5125 58.0783,3.5125 C58.9823,3.5125 59.7903,3.8465 60.1803,4.7085 C60.5973,4.0825 61.3493,3.5125 62.3513,3.5125 C63.8803,3.5125 64.9803,4.2225 64.9803,6.0855 L64.9803,10.9005 L63.0043,10.9005 L63.0043,6.8235 C63.0043,5.8635 62.9203,5.0715 61.7933,5.0715 C60.6803,5.0715 60.4713,5.9885 60.4713,6.8945 L60.4713,10.9005 L58.4963,10.9005 L58.4963,6.8665 C58.4963,6.0305 58.5523,5.0715 57.2993,5.0715 C56.9103,5.0715 55.9643,5.3205 55.9643,6.7265 L55.9643,10.9005 L53.9883,10.9005 L53.9883,3.7075 Z"
                              id="Fill-56"
                            />
                            <path
                              d="M69.4751,11.8054 C69.0441,12.9604 68.3621,13.4334 66.9981,13.4334 C66.5951,13.4334 66.1911,13.4064 65.7871,13.3644 L65.7871,11.7364 C66.1641,11.7644 66.5531,11.8204 66.9421,11.8054 C67.6241,11.7364 67.8471,11.0254 67.6241,10.4554 L65.0921,3.7074 L67.2071,3.7074 L68.8351,8.6334 L68.8631,8.6334 L70.4351,3.7074 L72.4801,3.7074 L69.4751,11.8054 Z"
                              id="Fill-58"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </a>

                  <div className="f1 f aic jcc">
                    <a
                      href="https://www.a24films.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="A24"
                    >
                      <svg
                        className=""
                        width="34px"
                        height="14px"
                        viewBox="0 0 34 14"
                        version="1.1"
                      >
                        <g
                          id="Page-1"
                          stroke="none"
                          strokeWidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <g
                            id="supercluster_website_desktop_dropbox_2018-11-20"
                            transform="translate(-234.000000, -1813.000000)"
                            fill="#000000"
                          >
                            <g
                              id="Group-3"
                              transform="translate(234.000000, 1813.000000)"
                            >
                              <path
                                d="M29.0203,10.3359 L24.3983,10.3359 L29.0203,5.1999 L29.0203,10.3359 Z M32.8043,10.3359 L32.8043,0.4659 L23.6023,10.6899 L16.5313,10.6899 C16.2283,10.6899 15.9853,10.4449 15.9853,10.1439 C15.9853,9.9379 16.0983,9.7589 16.2673,9.6659 C16.2713,9.6629 16.2763,9.6609 16.2813,9.6579 C16.9953,9.2909 17.6753,9.1009 18.0693,8.9899 L18.1873,8.9569 C18.4243,8.8889 18.7133,8.8249 19.0213,8.7569 C19.1283,8.7329 19.2383,8.7089 19.3513,8.6829 C21.2183,8.2559 23.7473,7.5229 23.7473,4.5399 C23.7473,3.8839 23.5803,3.2109 23.2003,2.6119 C22.5943,1.6559 21.4473,0.8849 19.5703,0.6579 C19.2013,0.6119 18.8043,0.5889 18.3773,0.5889 C15.4653,0.5889 13.4943,2.1199 13.4273,4.4119 C13.4263,4.4509 13.4243,4.4909 13.4243,4.5309 C13.4243,5.7969 14.4543,6.8269 15.7203,6.8269 C16.9853,6.8269 18.0153,5.7969 18.0153,4.5309 C18.0153,3.2649 16.9853,2.2359 15.7203,2.2359 C15.6503,2.2359 15.5813,2.2389 15.5133,2.2449 C15.5103,2.2459 15.5073,2.2459 15.5043,2.2459 C15.0323,2.2899 14.6023,2.4779 14.2573,2.7629 C14.5163,2.3559 14.8713,2.0049 15.3073,1.7219 C15.3133,1.7189 15.3203,1.7139 15.3263,1.7099 C16.1113,1.2069 17.1553,0.9229 18.3773,0.9229 C18.5073,0.9229 18.6353,0.9259 18.7613,0.9309 C18.7883,0.9319 18.8163,0.9329 18.8433,0.9339 C19.1143,0.9679 19.3233,1.1959 19.3233,1.4749 L19.3233,7.8369 C19.3233,8.1359 19.1183,8.3849 18.8413,8.4549 C18.8283,8.4579 18.8153,8.4609 18.8023,8.4649 C18.5453,8.5219 18.3033,8.5779 18.0953,8.6369 L17.9803,8.6689 C17.4163,8.8259 16.2433,9.1539 15.2023,9.9429 C14.8373,10.2189 14.5213,10.5269 14.2583,10.8629 C13.5833,11.7209 13.2433,12.7729 13.2433,13.9999 L20.6223,13.9999 L23.6023,10.6909 L29.0203,10.6909 L29.0203,13.9999 L32.8043,13.9999 L32.8043,10.6909 L33.7503,10.6909 L33.7503,10.3359 L32.8043,10.3359 Z"
                                id="Fill-60"
                              />
                              <path
                                d="M2.6616,10.7485 L4.9906,5.7685 L7.3126,10.7485 L2.6616,10.7485 Z M5.7676,3.2655 C5.2946,4.2435 4.3276,4.3465 4.3276,4.3465 L4.7936,5.3475 L4.7966,5.3525 L4.7936,5.3515 L0.7496,13.9995 L1.1406,13.9995 L2.4956,11.1025 L7.4776,11.1025 L8.8286,13.9995 L13.0046,13.9995 L6.8846,0.8755 L5.7676,3.2655 Z"
                                id="Fill-62"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </a>
                  </div>

                  <Link to="/dropbox" className="f1 f aic jcc" aria-label="Dropbox">
                    <span className="caps xsmall akkura m0 p0 mr15 inline-block">
                      Powered By
                    </span>
                    <svg
                      className=" inline-block"
                      width="83px"
                      height="17px"
                      viewBox="0 0 83 17"
                      version="1.1"
                    >
                      <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="supercluster_website_desktop_dropbox_2018-11-20"
                          transform="translate(-142.000000, -1813.000000)"
                          fill="#000000"
                        >
                          <g
                            id="Group-2"
                            transform="translate(142.000000, 1813.000000)"
                          >
                            <path
                              d="M9.8633,3.835 L5.0983,6.87 L9.8633,9.905 L5.0983,12.939 L0.3333,9.905 L5.0983,6.87 L0.3333,3.835 L5.0983,0.8 L9.8633,3.835 Z M5.0843,13.946 L9.8493,10.911 L14.6143,13.946 L9.8493,16.981 L5.0843,13.946 Z M9.8633,9.905 L14.6283,6.87 L9.8633,3.835 L14.6283,0.8 L19.3933,3.835 L14.6283,6.87 L19.3933,9.905 L14.6283,12.939 L9.8633,9.905 Z"
                              id="Fill-65"
                            />
                            <path
                              d="M23.1237,3.835 L26.9807,3.835 C29.4487,3.835 31.4627,5.267 31.4627,8.515 L31.4627,9.21 C31.4627,12.471 29.5617,13.946 27.0377,13.946 L23.1237,13.946 L23.1237,3.835 Z M25.2797,5.664 L25.2797,12.088 L26.9387,12.088 C28.3287,12.088 29.2787,11.167 29.2787,9.139 L29.2787,8.614 C29.2787,6.586 28.2997,5.664 26.8677,5.664 L25.2797,5.664 Z M32.6107,5.764 L34.3267,5.764 L34.5967,7.664 C34.9227,6.359 35.7597,5.693 37.2767,5.693 L37.8017,5.693 L37.8017,7.863 L36.9227,7.863 C35.1637,7.863 34.7387,8.472 34.7387,10.202 L34.7387,13.946 L32.6107,13.946 L32.6107,5.764 Z M38.2557,10.032 L38.2557,9.805 C38.2557,7.054 40.0137,5.579 42.3957,5.579 C44.8357,5.579 46.5227,7.083 46.5227,9.805 L46.5227,10.032 C46.5227,12.727 44.8637,14.159 42.3957,14.159 C39.7587,14.159 38.2557,12.727 38.2557,10.032 Z M44.3677,10.004 L44.3677,9.805 C44.3677,8.274 43.6017,7.38 42.3957,7.38 C41.2047,7.38 40.4107,8.217 40.4107,9.805 L40.4107,10.004 C40.4107,11.479 41.1627,12.301 42.3817,12.301 C43.6017,12.301 44.3677,11.493 44.3677,10.004 Z M47.6437,5.764 L49.4297,5.764 L49.6427,7.324 C50.0827,6.274 50.9907,5.579 52.3377,5.579 C54.4217,5.579 55.7837,7.083 55.7837,9.834 L55.7837,10.061 C55.7837,12.755 54.2657,14.159 52.3377,14.159 C51.0327,14.159 50.1677,13.578 49.7277,12.627 L49.7277,16.754 L47.6437,16.754 L47.6437,5.764 Z M53.6277,10.018 L53.6277,9.834 C53.6277,8.203 52.7917,7.395 51.6707,7.395 C50.4797,7.395 49.6857,8.302 49.6857,9.819 L49.6857,9.976 C49.6857,11.422 50.4517,12.33 51.6287,12.33 C52.8477,12.33 53.6277,11.521 53.6277,10.018 Z M58.9177,12.457 L58.7477,13.946 L56.9037,13.946 L56.9037,3.027 L58.9887,3.027 L58.9887,7.224 C59.4427,6.161 60.3497,5.579 61.6407,5.579 C63.5837,5.594 65.0297,6.941 65.0297,9.664 L65.0297,9.905 C65.0297,12.627 63.6687,14.159 61.5837,14.159 C60.2367,14.159 59.3577,13.507 58.9177,12.457 Z M62.8887,9.905 L62.8887,9.706 C62.8887,8.203 62.0657,7.38 60.9317,7.38 C59.7547,7.38 58.9457,8.331 58.9457,9.734 L58.9457,9.905 C58.9457,11.436 59.7257,12.315 60.9027,12.315 C62.1367,12.315 62.8887,11.521 62.8887,9.905 Z M65.9797,10.032 L65.9797,9.805 C65.9797,7.054 67.7247,5.579 70.1067,5.579 C72.5457,5.579 74.2477,7.083 74.2477,9.805 L74.2477,10.032 C74.2477,12.727 72.5747,14.159 70.1067,14.159 C67.4687,14.159 65.9797,12.727 65.9797,10.032 Z M72.0917,10.004 L72.0917,9.805 C72.0917,8.274 71.3267,7.38 70.1207,7.38 C68.9297,7.38 68.1357,8.217 68.1357,9.805 L68.1357,10.004 C68.1357,11.479 68.8867,12.301 70.1067,12.301 C71.3407,12.301 72.0917,11.493 72.0917,10.004 Z M77.0277,9.706 L74.1627,5.764 L76.6157,5.764 L78.2757,8.217 L79.9487,5.764 L82.3877,5.764 L79.4807,9.692 L82.5437,13.946 L80.1327,13.946 L78.2467,11.238 L76.4177,13.946 L73.9217,13.946 L77.0277,9.706 Z"
                              id="Fill-66"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(HeaderFullscreen);
